import { createContext } from 'react';

interface IOutrightsBySportContext {
    outrightsCountBySport: Record<string, number>;
}

export const OutrightsBySportContext = createContext<IOutrightsBySportContext>({
    outrightsCountBySport: {},
});
